import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { useStore } from "@/store/useStore";

/* A 3D flashlight toggle that lives inside the Canvas/XR tree so a VR controller
   ray (or a mouse) can select it during an immersive session, where the DOM
   ProductPanel button is unreachable. */
export default function InSceneFlashlight() {
  const flashlight = useStore((s) => s.flashlight);
  const toggleDevice = useStore((s) => s.toggleDevice);
  const halo = useRef();

  useFrame((state) => {
    if (halo.current) {
      const t = state.clock.elapsedTime;
      halo.current.material.opacity = flashlight ? 0.5 + Math.sin(t * 5) * 0.2 : 0.18;
    }
  });

  const color = flashlight ? "#ffd166" : "#5b6472";

  return (
    <group
      position={[-1.1, -1.7, 1.4]}
      onClick={(e) => {
        e.stopPropagation();
        toggleDevice("flashlight");
      }}
      onPointerOver={() => (document.body.style.cursor = "pointer")}
      onPointerOut={() => (document.body.style.cursor = "auto")}
    >
      {/* base disc */}
      <mesh rotation={[-Math.PI / 2, 0, 0]}>
        <cylinderGeometry args={[0.34, 0.34, 0.05, 32]} />
        <meshStandardMaterial color="#0b0f18" metalness={0.5} roughness={0.5} />
      </mesh>
      {/* glowing core */}
      <mesh position={[0, 0.12, 0]}>
        <sphereGeometry args={[0.16, 24, 24]} />
        <meshStandardMaterial color={color} emissive={color} emissiveIntensity={flashlight ? 1.4 : 0.3} toneMapped={false} />
      </mesh>
      {/* pulsing halo */}
      <mesh ref={halo} position={[0, 0.12, 0]} rotation={[-Math.PI / 2, 0, 0]}>
        <ringGeometry args={[0.2, 0.3, 32]} />
        <meshBasicMaterial color={color} transparent opacity={0.18} toneMapped={false} />
      </mesh>
    </group>
  );
}
